/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientPlaylistModel } from '../../models/patient-playlist-model';

export interface GetPatientPlaylists$Params {
  patientID?: number;
  onlyActive?: boolean;
  lightLoad?: boolean;
}

export function GetPatientPlaylists(http: HttpClient, rootUrl: string, params?: GetPatientPlaylists$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientPlaylistModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientPlaylists.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
    rb.query('lightLoad', params.lightLoad, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientPlaylistModel>>;
    })
  );
}

GetPatientPlaylists.PATH = '/api/Supervisor/GetPatientPlaylists';
